import React from "react";
import { ErrorMessage } from "formik";
import { generateClassString as gcs } from "../../../lib/helper/generateClassString";

// import all form inputs
import TextInput from "./TextInput";
import { FormikSelect as SelectInput } from "./SelectInput/Formik";
import TextAreaInput from "./TextAreaInput";
import CheckboxInput from "./CheckboxInput";
import RadioGroupInput from "./RadioGroupInput";
import NumberInput from "./NumberInput";

import * as styles from "./component.module.less";

export default function FormField({
    labelClass,
    className,
    name,
    label,
    type,
    required = false,
    placeholder,
    options,
    rows,
    // onChange,
    // value,
    ...props
}) {
    const fields = {
        text: TextInput,
        select: SelectInput,
        textarea: TextAreaInput,
        checkbox: CheckboxInput,
        radiogroup: RadioGroupInput,
        number: NumberInput,
    };

    const InputField = fields[type];

    return (
        <>
            {type === "checkbox" ? (
                <>
                    <div className={gcs(styles.field, styles.checkBoxField)}>
                        <InputField
                            className={gcs(className, styles.inputField)}
                            name={name}
                            id={name}
                            placeholder={placeholder}
                            options={options}
                            rows={rows}
                            // {...(onChange ?? {})}
                            // {...(value ?? {})}
                            // onChange={onChange}
                            // value={value}
                            {...props}
                        />

                        {label && (
                            <label
                                className={gcs(labelClass, styles.inputLabel)}
                                htmlFor={name}
                            >
                                {label} {required && <span>*</span>}
                            </label>
                        )}
                    </div>
                    <ErrorMessage name={name}>
                        {(msg) => <p className={styles.invalidText}>{msg}</p>}
                    </ErrorMessage>
                </>
            ) : (
                <div className={styles.field}>
                    <InputField
                        className={gcs(className, styles.inputField)}
                        name={name}
                        id={name}
                        placeholder={placeholder}
                        options={options}
                        rows={rows}
                        // {...(onChange ?? {})}
                        // {...(value ?? {})}
                        // onChange={onChange}
                        // value={value}
                        {...props}
                    />

                    {label && (
                        <label
                            className={gcs(labelClass, styles.inputLabel)}
                            htmlFor={name}
                        >
                            {label} {required && <span>*</span>}
                        </label>
                    )}

                    <ErrorMessage name={name}>
                        {(msg) => <p className={styles.invalidText}>{msg}</p>}
                    </ErrorMessage>
                </div>
            )}
        </>
    );
}
